/**
 * @title myorders-fsa.js: Sub-module for Account pages
 * @description This module is used to handle my orders fsa tasks
 * @dependency 
 */
define(['myOrdersHelper'], function(myOrdersHelper) {	
  
  let MyOrdersFSA = {

    /**
     * Initialization of the module.
     */
    init : function() {
	  console.log("My Orders FSA module intialized.");
	  $('#aloadmoreleft').bind("click", this, MyOrdersFSA.showMore);
    },
    /**
     * show FSA orders for selected period 
     */
    showFSAOrdersForPeriod : function(){
    	let selectedPeriod = $('option:selected', "#select-period").attr('data-select-option');
    	let _selectedPeriod = jQuery.parseJSON(selectedPeriod);
    	console.log("Selected period is  " + selectedPeriod);
    	console.log("Selected period is  " + _selectedPeriod.startyear);
    	
    	$('#selection').val(_selectedPeriod.index);
		$('#fromYear').val(_selectedPeriod.startyear);
		$('#fromMonth').val(_selectedPeriod.startmonth);
		$('#toYear').val(_selectedPeriod.endyear);
		$('#toMonth').val(_selectedPeriod.endmonth);
		$('#OrderStatusTableDisplayForm').submit();
    },
    /**
     * expand all rows
     */
    expandAll : function(){
    	if($('div > #expend-all > a').text().trim() === messages.MY_ORDERS_FSA_EXPAND_ALL) {
    		$('[id^="heading-2-"]').each(function(i, obj){
    			if($(this).attr('aria-expanded') === 'false') {
    				$(this).click();
    		    }
    		});
    		$('div > #expend-all > a').text(messages.MY_ORDERS_FSA_COLLAPSE_ALL);
    		
    	} else {
    		$('[id^="heading-2-"]').each(function(i, obj){
    			if($(this).attr('aria-expanded') === 'true') {
    				$(this).click();
    		    }
    		});
    		$('div > #expend-all > a').text(messages.MY_ORDERS_FSA_EXPAND_ALL);
    	}
    },
    /**
     * show more FSA orders
     */
    showMore : function(e){
    	if(!curPage){
			  curPage = 0;
		  }
		  curPage++;
		  $('.order-ajax').addClass('ajax-busy');

		  myOrdersHelper.ajax_update_state({
			  url: '/AjaxOrderStatusCmd'+ '?URL=OrderStatusSummaryFSAView&orderType=1&defaultFSA=True&currentPage=' + curPage+ '&fromYear=' + fromYear + '&fromMonth=' + fromMonth + '&toYear=' + toYear + '&toMonth=' + toMonth,
			  method: 'GET',
	          data: ''
		  });			 
		  if(curPage >= totPages - 1) {
			  $('#aloadmoreleft').hide();
		  }
		  e.preventDefault();
    }
  }
  
  if (typeof window.COSTCO === "undefined") {
    window.COSTCO = new Object();
  }
  
  window.COSTCO.MyOrdersFSA = MyOrdersFSA;
  
  return MyOrdersFSA;
});



// WEBPACK FOOTER //
// ./js/account/myorders-fsa.js